/* =================== CONTADORES CARROSEL=================== */
$(function () {
  $(".contadores-carrosel").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    arrows: false,
    linear: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 760,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
});

/* =================== CONTADORES ANIMAÇÃO=================== */
(function () {
  "use strict";

  // Variáveis
  const $container = $(".slide-home");
  const $counters = $(".contador-num");
  const duration = 2000;

  // Verifica os contadores existem
  if ($container.length > 0) {
    // Inicia os contadores quando estiverem visíveis na tela
    doWhenVisibleWithoutScroll($container, function () {
      $counters.each(function () {
        // Variáveis
        const $el = $(this);
        const countTo = $el.attr("data-count");

        // Contador
        $({
          countCur: $el.text(),
        }).animate(
          {
            countCur: countTo,
          },
          {
            duration: duration,
            easing: "swing",
            step: function () {
              $el.text(Math.floor(this.countCur));
            },
            complete: function () {
              $el.text(this.countCur);
            },
          }
        );
      });
    });
  }
})();
